const getters = {
  // sidebar: state => state.app.sidebar,
  isNewWebRich: (state) => state.app.eventId > 2112,
  homename: (state) => state.app.homename,
}
export default getters